import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './App.css';
import './assets/css/FontStyles.css';
import Home from './screens/student/home/Home';
import About from './screens/about/About';
import Contact from './screens/contact/Contact';
import UserLayout from './components/general/UserLayout';
import AdminLayout from "./layouts/admin/adminlayout/AdminLayout";
// import AdminDashboard from "./screens/admin/admin/dashboard/AdminDashboard";
import Users from "./screens/admin/users/Users";
import SubAdmin from "./screens/admin/subAdmin/SubAdmin";
import Mentors from "./screens/admin/mentors/Mentors";
import "./assets/css/admin/global.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import StudentLayout from "./layouts/student/studentlayout/StudentLayout";
import MyStudyGroup from "./screens/student/mystudygroups/MyStudyGroups";
import StudyCalendar from "./screens/student/studycalendar/StudyCalendar";
import CollaborativeBoard from "./screens/student/collaborativeboard/CollaborativeBoard";
import ResourcesLibrary from "./screens/student/resourceslibrary/ResourcesLibrary";
import AiStudyAssistant from "./screens/student/aistudyassistant/AIStudyAssistant";
import QuizzesAndTest from "./screens/student/quizzesandtest/QuizzesAndTest";
import FlashCards from "./screens/student/flashcards/FlashCards";
import MyProgress from "./screens/student/myprogress/MyProgress";
import StudentSettings from "./screens/student/studentSettings/StudentSettings";
import Notifications from "./screens/student/notifications/Notifications";
import StudentDashboard from './screens/student/studentDashboard/StudentDashboard';
import Login from './components/general/login';
import AdminLogin from './screens/admin/auth/AdminLogin'; //admin login
import IlamAI from './screens/ai/IlamAI';
import Domains from './screens/domains/Domains';
import Students from './screens/admin/students/Students.js';
import AdminStudyGroups from './screens/admin/adminStudyGroups/AdminStudyGroups.js';
import FilesAndNotes from './screens/admin/filesAndNotes/FilesAndNotes.js';
import Reports from './screens/admin/reports/Reports.js';
import AdminSubjects from './screens/admin/adminSubjects/AdminSubjects.js';
import AdminNotifications from './screens/admin/adminNotifications/AdminNotifications.js';
import AdminSettings from './screens/admin/adminSattings/AdminSettings.js';
import StudySessions from './screens/admin/studysession/StudySessions.js';
import AdminDashboard from './screens/admin/dashboard/AdminDashboard.js';
import GroupClass from './screens/student/studycalendar/GroupClass.jsx';

function App() {
  // Simple authentication state (expand this with Context API)
  const [isAuthenticated, setIsAuthenticated] = React.useState(
    localStorage.getItem("isAuthenticated") === "true"
  );

  const handleLogin = () => {
    setIsAuthenticated(true);
    localStorage.setItem("isAuthenticated", "true");
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem("isAuthenticated");
  };
  const isAdminLoggedIn = localStorage.getItem('adminLoggedIn') === 'true'; //new


  return (
      <Routes>
        {/* Public Routes */}
        <Route element={<UserLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/ai" element={<IlamAI />} />
          <Route path="/domains" element={<Domains />} />
          <Route path="/contact" element={<Contact />} />
        </Route>

        <Route 
          path="/login" 
          element={<Login />} 
        />
         ✅ NEW: ADMIN LOGIN
        <Route 
          path="/admin-login" 
          element={<AdminLogin />} 
        />
        {/* Student Routes */}
        <Route path="/my-study-group" element={<MyStudyGroup />} />
        <Route path="/study-calendar" element={<StudyCalendar />} />
        <Route path="/study-sessions" element={<StudySessions />} />
        <Route path="/collaborative-board" element={<CollaborativeBoard />} />
        <Route path="/resources-library" element={<ResourcesLibrary />} />
        <Route path="/ai-study-assistant" element={<AiStudyAssistant />} />
        <Route path="/quizzes-and-test" element={<QuizzesAndTest />} />
        <Route path="/flash-cards" element={<FlashCards />} />
        <Route path="/my-progress" element={<MyProgress />} />
        <Route path="/student-Settings" element={<StudentSettings />} />
        <Route path="/notifications" element={<Notifications />} />
        <Route path="/student-Dashboard" element={<StudentDashboard />} />
        <Route path="/student-groupcall/:title" element={<GroupClass />} />

        {/* Admin Routes */}
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/students" element={<Students />} />
        <Route path="/sub-admin" element={<SubAdmin />} />
        <Route path="/mentors" element={<Mentors />} />
        <Route path="/admin-study-groups" element={<AdminStudyGroups />} />
        <Route path="/files-And-Notes" element={<FilesAndNotes />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/admin-subjects" element={<AdminSubjects />} />
        <Route path="/admin-notifications" element={<AdminNotifications />} />
        <Route path="/admin-settings" element={<AdminSettings />} />
        
        {/* 404 Route */}
        <Route path="*" element={<h1>PAGE NOT FOUND</h1>} />
      </Routes>
  );
}

export default App;